import axios from "axios";
import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { apis } from "../../api/apiUrl";

const OurPeopleDialogue = ({ id, title }) => {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    const fetchData = async (searchTerm) => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.post(
          `${apis.uniten_api}/GetStaffName`,
          {
            name: searchTerm,
            CollegeId: id,
            LecturerId: null,
            currentPage: 1,
          }
        );
        setData(response.data.data || []);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    // Fetch data immediately on load
    if (search === "") {
      fetchData("");
    }

    // Debounced fetch for search input
    const timer = setTimeout(() => {
      if (search !== "") {
        fetchData(search);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [search, id]);

  return (
    <div className="flex flex-col gap-5 min-w-[60vw]  max-w-full w-full">
      <div className="w-full flex flex-col items-center justify-center gap-8 p-4 pt-10 lg:p-14 bg-[#3d4a6c]">
        <h1 className="text-[clamp(.9rem,5vw,2.5rem)] text-white font-bold ">
          {title}
        </h1>
        <div className="relative w-full bg-white flex items-center gap-3 text-black rounded-xl overflow-hidden">
          <FaSearch className="ml-8 w-5 h-5" />
          <input
            type="text"
            placeholder="Search Name"
            value={search}
            onChange={handleSearch}
            className="w-full h-full p-3 lg:p-5 font-medium placeholder:font-medium text-black placeholder:text-gray-700 outline-none border-none"
          />
        </div>
      </div>
      <div className="w-full max-w-4xl self-center p-4 lg:p-8 overflow-y-auto scroll-bar">
        {loading ? (
          <div className="w-full h-full flex items-center justify-center gap-3">
            <div className="w-5 h-5 border-2 border-t-[4px] border-t-[#3d4a6c] rounded-full animate-spin"></div>
            <span className="text-[#3d4a6c] font-bold">Loading...</span>
          </div>
        ) : error ? (
          <div className="w-full h-full flex items-center justify-center gap-3">
            <span className="text-red-500 font-bold">{error}</span>
          </div>
        ) : data?.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3  w-full place-items-center gap-8">
            {data.map((d, i) => (
              <div
                key={i}
                className="w-60  h-[20rem] relative border shrink-0 snap-center group select-none bg-slate-500/30 rounded-3xl overflow-hidden bg-cover bg-no-repeat bg-center"
                style={{
                  backgroundImage: `url('data:image/jpeg;base64,${d?.staffProfile}')`,
                }}
              >
                <div className="absolute w-full h-full top-0 bg-gradient-to-b from-black/20 to-black/40 z-20 opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
                <div className="absolute bottom-0 w-full h-2/5 2xl:h-1/3 bg-gradient-to-b from-[#6e6e76]/30 to-[#1b1b1d] px-5 p-4">
                  <h1 className="text-white  font-bold text-sm 2xl:text-lg">
                    {d?.name}
                  </h1>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="w-full h-full flex items-center justify-center gap-3">
            <span className="text-[#3d4a6c] font-bold">No Data Found</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default OurPeopleDialogue;
